import { ReactElement } from "react";

//estilos
const classes = require("./TimelineCard.module.css").default;

type Props = {
  titulo: string;
  descripcion: string;
  icono: ReactElement;
};

const TimelineCard = ({ titulo, descripcion, icono }: Props) => {
  return (
    <div style={{ cursor: "pointer" }}>
      <div
        className={`${classes.singleTimelineContent} d-flex wow fadeInLeft`}
        data-wow-delay="0.3s"
        style={{
          visibility: "visible",
          animationDelay: "0.3s",
          animationName: "fadeInLeft",
        }}
      >
        <div className={`${classes.timelineIcon}`}>{icono}</div>
        <div className={`${classes.timelineText}`}>
          <h6>{titulo}</h6>
          <p>{descripcion}</p>
        </div>
      </div>
    </div>
  );
};

export default TimelineCard;
